<script>
import dialogMixin from "./mixins/dialog";
export default {
  mixins: [dialogMixin],
  props: {
    value: {
      type: Object,
      default: () => {
        return {

        }
      },
    },
    isChildren: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      payMethods: {
        Cash: '到店付款(現金)',
        StoreCredit: '現場刷卡',
        Atm: '線下匯款',
      },
      loading: false,
      submitRules: {
        Card4No: [
          {
            required: !!this.value.Card4No,
            pattern: /^[0-9]{4}$/,
            message: '請輸入四碼數字',
            trigger: 'blur'
          },
        ],
        PayerAccount5Code: [
          {
            required: !!this.value.PayerAccount5Code,
            pattern: /^[0-9]{5}$/,
            message: '請輸入五碼數字',
            trigger: 'blur'
          },
        ],
      }
    }
  },
  computed: {
    submitData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    testNumber() {

    },
    async onClickSubmit() {
      if (this.$refs.form) {
        await this.$refs.form.validate()
      }
      this.$emit('submit', { ...this.submitData })
      this.dialogMixinDialogVisible = false
    },
    cancelSubmit() {
      this.$refs.form.resetFields()
    }
  },
}
</script>
<template>
  <el-dialog :visible.sync="dialogMixinDialogVisible" :before-close="$DialogMixinOnClose"
    :custom-class="`${$style.DialogPaidConfirm} `" width="550px" append-to-body top="0" :close-on-click-modal="false"
    :close-on-press-escape="false" @close="cancelSubmit">
    <div slot="title">
      <div style="margin-bottom: 10px">{{`${isChildren ? '子訂單' : '訂單'}`}}付款確認</div>
    </div>
    <template>
        <div class="text-center">{{`${isChildren ? '子訂單' : '訂單'}: ${ type === 'prepaid' ? submitData.orderNo : submitData.id }`}}</div>
        <div v-if="submitData.paymentMethod" class="text-center mt-2 mb-4">{{` 確認付款方式為「 ${payMethods[submitData.paymentMethod]} 」？ `}}</div>
        <el-form 
          ref="form" 
          :class="$style.team" 
          :model="submitData"
          label-position="top"
          :rules="submitRules"
          class="isStyleLabelLight"
        >
          <el-form-item 
            v-if="submitData.paymentMethod === 'StoreCredit'"
            
            prop="Card4No"
            label="信用卡末四碼"
          >
            <div class="el-form-item el-form-item--white-bg-border">
              <el-input 
                v-model="submitData.Card4No" 
                maxlength="4" minlength="4"
                placeholder="請輸入"
                > 
              </el-input>
            </div>
          </el-form-item>
          <el-form-item 
            v-if="submitData.paymentMethod === 'Atm'"
            prop="PayerAccount5Code"
            label="匯款帳號末五碼"
          >
            <div class="el-form-item el-form-item--white-bg-border">
              <el-input 
                v-model="submitData.PayerAccount5Code" 
                maxlength="5" minlength="5"
                placeholder="請輸入"
              > 
              </el-input>
            </div>
          </el-form-item>
        </el-form>
        <el-button type="primary" class="is-round is-fullwidth mt-3" :disabled="loading" :loading="loading" @click="onClickSubmit()"> 是 </el-button>
        <el-button class="is-round is-fullwidth" :disabled="loading" :loading="loading" @click="dialogMixinDialogVisible = false"> 否 </el-button>
    </template>
  </el-dialog>
</template>
<style lang="scss" module>
.dialogLogin {
  :global {}
}
</style>
